<template>
  <div v-show="editShow">
    <div class="container">
      <el-row :gutter="20">
        <div class="clearfix">
          <div class="crumbs">
            <i class="el-icon-back"></i>
            <el-button type="text" @click="goBack">返回</el-button>
          </div>
          <div class="btn-save">
            <el-button type="primary" @click="saveClick('ruleForm')"
            >保存
            </el-button
            >
          </div>
        </div>
        <div class="form-box">
          <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="120px"
              class="eidt-el-form"
          >
            <el-form-item label="公安审核" prop="disabled">
              <el-radio-group
                  v-model="ruleForm.disabled"
                  @change="getDisabledRadio"
              >
                <el-radio :label="0">未审核</el-radio>
                <el-radio :label="1">已审核</el-radio>
                <el-radio :label="2">审核不通过</el-radio>
                <el-radio :label="3">无效身份证</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="姓名" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="英文姓名" prop="nameEn">
              <el-input v-model="ruleForm.nameEn"></el-input>
            </el-form-item>
            <el-form-item label="性别/称呼" prop="sex">
              <el-input v-model="ruleForm.sex"></el-input>
            </el-form-item>
            <el-form-item label="手机" prop="phone">
              <el-input v-model="ruleForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="码值" prop="code">
              <el-input v-model="ruleForm.code"></el-input>
            </el-form-item>
            <el-form-item label="编号" prop="idNumber">
              <el-input v-model="ruleForm.idNumber"></el-input>
            </el-form-item>
            <el-form-item label="是否入库" prop="isMake">
              <el-switch v-model="ruleForm.isMake"></el-switch>
            </el-form-item>
            <el-form-item label="入库时间" prop="makeDate">
              <el-date-picker
                  v-model="ruleForm.makeDate"
                  type="datetime"
                  placeholder="入库时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="是否打印" prop="isPrint">
              <el-switch v-model="ruleForm.isPrint"></el-switch>
            </el-form-item>
            <el-form-item label="打印时间" prop="printDate">
              <el-date-picker
                  v-model="ruleForm.printDate"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="打印时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="证件类型" prop="documentTypeId">
              <el-select
                  v-model="ruleForm.documentTypeId"
                  placeholder="选择证件类型"
              >
                <el-option
                    v-for="(type, index) in DocumentType"
                    :label="type.name"
                    :key="index"
                    :value="type.documentTypeId"
                >
                  <div @click="getChangeType(type)">{{ type.name }}</div>
                </el-option>
              </el-select>
            </el-form-item>
            <UploadImg
                @uploadImg="getUploadImg"
                :editImg="editImg"
                :imgTitle="imgTitle"
            ></UploadImg>
            <el-form-item label="身份证" prop="idCard">
              <el-input v-model="ruleForm.idCard"></el-input>
            </el-form-item>
            <el-form-item label="省份" prop="province">
              <el-input v-model="ruleForm.province"></el-input>
            </el-form-item>
            <el-form-item label="城市" prop="city">
              <el-input v-model="ruleForm.city"></el-input>
            </el-form-item>
            <el-form-item label="区县" prop="area">
              <el-input v-model="ruleForm.area"></el-input>
            </el-form-item>
            <el-form-item label="年龄" prop="age">
              <el-input v-model="ruleForm.age"></el-input>
            </el-form-item>
            <el-form-item label="rfid" prop="rfid">
              <el-input v-model="ruleForm.rfid"></el-input>
            </el-form-item>
            <el-form-item label="公司" prop="company">
              <el-input v-model="ruleForm.company"
                        type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="公司英文" prop="companyEn">
              <el-input v-model="ruleForm.companyEn"
                        type="textarea"></el-input>
            </el-form-item>
            <el-form-item label="团组" prop="groupNo">
              <el-input v-model="ruleForm.groupNo"></el-input>
            </el-form-item>
            <el-form-item label="展位号码" prop="booth">
              <el-input v-model="ruleForm.booth"></el-input>
            </el-form-item>
            <el-form-item label="职位" prop="position">
              <el-input v-model="ruleForm.position"></el-input>
            </el-form-item>
            <el-form-item label="职务英文" prop="positionEn">
              <el-input v-model="ruleForm.positionEn"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="ruleForm.email"></el-input>
            </el-form-item>
            <el-form-item label="头像" prop="avatar">
              <img :src="ruleForm.avatar" v-if="ruleForm.avatar" width="200px">
              <el-input v-model="ruleForm.avatar"></el-input>
            </el-form-item>
            <el-form-item label="原图">
              <img :src="ruleForm.originalImg" v-if="ruleForm.originalImg" width="200px">
              <el-input v-model="ruleForm.originalImg"></el-input>
            </el-form-item>
            <el-form-item label="座位号" prop="visit">
              <el-input v-model="ruleForm.visit"></el-input>
            </el-form-item>
            <el-form-item label="有效时间">
              <el-date-picker
                  v-model="ruleForm.effectiveDate"
                  type="datetimerange"
                  @change="dateChange"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="有效时间"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="有效时间开始" prop="effectiveStart">
              <el-input v-model="ruleForm.effectiveStart"></el-input>
            </el-form-item>
            <el-form-item label="有效时间结束" prop="effectiveEnd">
              <el-input v-model="ruleForm.effectiveEnd"></el-input>
            </el-form-item>
            <el-form-item label="标签" prop="label">
              <el-input v-model="ruleForm.label"></el-input>
            </el-form-item>
            <el-form-item label="参会身份" prop="role">
              <el-input v-model="ruleForm.role"></el-input>
            </el-form-item>
            <!--            <el-form-item label="是否参加开幕式" prop="openingCeremony">-->
            <!--              <el-input v-model="ruleForm.openingCeremony"></el-input>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="是否参加闭幕式" prop="closingCeremony">-->
            <!--              <el-input v-model="ruleForm.closingCeremony"></el-input>-->
            <!--            </el-form-item>-->
            <el-form-item label="行政级别" prop="profile">
              <el-input v-model="ruleForm.profile"></el-input>
            </el-form-item>
            <el-form-item label="地址" prop="address">
              <el-input v-model="ruleForm.address"></el-input>
            </el-form-item>
            <el-form-item label="三要素核验" prop="status">
              <el-input v-model="ruleForm.status"></el-input>
            </el-form-item>
            <el-form-item label="二要素核验" prop="status2">
              <el-input v-model="ruleForm.status2"></el-input>
            </el-form-item>
            <el-form-item label="ZD核验" prop="zd">
              <el-input v-model="ruleForm.zd"></el-input>
            </el-form-item>
            <el-form-item label="参与分论坛" prop="market">
              <el-input v-model="ruleForm.market"></el-input>
            </el-form-item>
            <el-form-item label="业务范围" prop="business">
              <el-input v-model="ruleForm.business"></el-input>
            </el-form-item>
            <el-form-item label="业务类型" prop="profile">
              <el-input v-model="ruleForm.profile"></el-input>
            </el-form-item>
            <!--            <el-form-item label="城市" prop="city">-->
            <!--              <el-input v-model="ruleForm.city"></el-input>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="省份" prop="province">-->
            <!--              <el-input v-model="ruleForm.province"></el-input>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="国家" prop="countryArea">-->
            <!--              <el-input v-model="ruleForm.countryArea"></el-input>-->
            <!--            </el-form-item>-->
            <el-form-item label="住宿意向" prop="accommodate">
              <el-input v-model="ruleForm.accommodate"></el-input>
            </el-form-item>
            <el-form-item label="入住时间" prop="checkInTime">
              <el-input v-model="ruleForm.checkInTime"></el-input>
            </el-form-item>
            <el-form-item label="离开时间" prop="departureTime">
              <el-input v-model="ruleForm.departureTime"></el-input>
            </el-form-item>
            <el-form-item label="房间类型" prop="roomtype">
              <el-input v-model="ruleForm.roomtype"></el-input>
            </el-form-item>
            <el-form-item label="房间号" prop="roomNo">
              <el-input v-model="ruleForm.roomNo"></el-input>
            </el-form-item>
            <el-form-item label="酒店" prop="hotel">
              <el-input v-model="ruleForm.hotel"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input v-model="ruleForm.remark"></el-input>
            </el-form-item>
            <el-form-item label="备注1" prop="remark1">
              <el-input v-model="ruleForm.remark1"></el-input>
            </el-form-item>
            <el-form-item label="备注2" prop="remark2">
              <el-input v-model="ruleForm.remark2"></el-input>
            </el-form-item>
            <el-form-item label="备注3" prop="remark3">
              <el-input v-model="ruleForm.remark3"></el-input>
            </el-form-item>
            <el-form-item label="备注4" prop="remark4">
              <el-input v-model="ruleForm.remark4"></el-input>
            </el-form-item>
            <el-form-item label="备注5" prop="remark5">
              <el-input v-model="ruleForm.remark5"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import UploadImg from "../../public/UploadImg";

export default {
  name: "editprojectmanage",
  data() {
    return {
      rules: {
        name: [{required: true, message: "名称不能为空", trigger: "blur"}],
        // code: [{required: true, message: "编号不能为空", trigger: "blur"}],
        // idNumber: [
        //     {required: true, message: "码值不能为空", trigger: "blur"},
        // ],
        documentTypeId: [
          {required: true, message: "请选择证件类型", trigger: "blur"},
        ],
      },
      ruleForm: {
        disabled: 0,
        makeDate: "",
        printDate: "",
        isPrint: null,
        isMake: null,
        name: "",
        documentTypeId: "",
        code: "",
        phone: "",
        remark: "",
        remark1: "",
        remark2: "",
        remark3: "",
        remark4: "",
        remark5: "",
        idNumber: "",
        typeName: "",
        avatar: "",
        projectId: this.projectId,
        company: "",
        nameEn: "",
        companyEn: "",
        positionEn: "",
        addressEn: "",
        area: "",
        rfid: "",
        groupNo: "",
        business: "",
        profile: "",
        visit: "",
        booth: "",
        market: "",
        status: "",
        status2: "",
        zd: "",
        effectiveStart: "",
        effectiveEnd: "",
        effectiveDate: "",
        hotel: "",
        roomtype: "",
        roomNo: "",
        age: "",
        province: "",
        city: "",
        address: "",
        role: "",
        label: "",
        openingCeremony: "",
        closingCeremony: "",
        accommodate: "",
        departureTime: "",
        checkInTime: "",
        department: "",
      },
      editImg: "",
      document_Id: "",
      dataList: [],
      ticketTypeId: "",
      projectId: localStorage.getItem("project_Id"),
      DocumentType: [],
      imgTitle: "上传头像",
    };
  },
  props: {
    editShow: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
    },
  },
  created() {
    this.projectId = localStorage.getItem("project_Id");
    this.getTicketType();
  },
  watch: {
    editData: function () {
      this.ruleForm = this.editData;
      if (!this.editData) {
        this.ruleForm = {
          disabled: 0,
          name: "",
          documentTypeId: "",
          code: "",
          phone: "",
          remark: "",
          remark1: "",
          remark2: "",
          remark3: "",
          remark4: "",
          remark5: "",
          idNumber: "",
          typeName: "",
          avatar: "",
          projectId: this.projectId,
          company: "",
          nameEn: "",
          companyEn: "",
          positionEn: "",
          addressEn: "",
          rfid: "",
          groupNo: "",
          booth: "",
          market: "",
          status: "",
          effectiveStart: "",
          effectiveEnd: "",
          effectiveDate: "",
          hotel: "",
          roomtype: "",
          roomNo: "",
          countryArea: "",
          province: "",
          city: "",
          area: "",
          age: "",
          address: "",
          role: "",
          profile: "",
          label: "",
          accommodate: "",
          departureTime: "",
          checkInTime: "",
        };
      } else {
        try {
          this.document_Id = item.documentId;
          this.editImg = item.avatar;
          if (this.ruleForm.effectiveStart) {
            this.ruleForm.effectiveDate = [this.ruleForm.effectiveStart, this.ruleForm.effectiveEnd];
          }
        } catch (e) {

        }
      }
    },
  },
  methods: {
    dateChange(data) {
      this.ruleForm.effectiveStart = data[0]
      this.ruleForm.effectiveEnd = data[1]
    },
    getDisabledRadio(value) {
      this.ruleForm.disabled = value;
    },
    saveClick(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          this.ruleForm.projectId = this.projectId;
          if (this.document_Id == "" || this.document_Id == undefined) {
            this.$axios.post("/Document/", this.ruleForm).then((res) => {
              if (res.data.hasError == false) {
                this.$message.success("保存成功！");
                this.goBack();
                this.$refs[ruleForm].resetFields();
              } else {

                this.$message.error(res.data.message);
              }
            });
          } else {
            this.$axios
                .put("/Document/" + this.document_Id + "", this.ruleForm)
                .then((res) => {
                  if (res.data.hasError == false) {
                    this.$message.success("编辑成功！");
                    this.goBack();
                    this.$refs['ruleForm'].resetFields();
                  } else {

                    this.$message.error(res.data.message);
                  }
                });
          }
        } else {
          return false;
        }
      });
    },
    goBack() {
      this.editImg = null;
      this.editData = null;
      this.document_Id = "";
      this.$refs["ruleForm"].resetFields();
      this.$emit("backFunStu");
    },
    getUploadImg(imgSrc) {
      this.ruleForm.avatar = imgSrc;
    },
    getTicketType() {
      this.$axios.get("/DocumentType/Project/" + this.projectId).then((res) => {
        if (res.data.hasError == false) {
          this.DocumentType = [...res.data.data];
        }
      });
    },
    getChangeType(type) {
      this.ruleForm.documentTypeId = type.documentTypeId;
      this.ruleForm.typeName = type.name;
    },
  },
  components: {
    UploadImg,
  },
};
</script>